import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldIcon, CreditCardIcon, FileTextIcon, FlagIcon } from 'lucide-react';
export function FinalCTA() {
  const trustBadges = [{
    icon: <LockIcon className="w-4 h-4" data-id="element-60" />,
    text: 'Pago 100% seguro'
  }, {
    icon: <ZapIcon className="w-4 h-4" data-id="element-61" />,
    text: 'Acceso en 5 minutos'
  }, {
    icon: <ShieldIcon className="w-4 h-4" data-id="element-62" />,
    text: 'Garantía 7 días'
  }, {
    icon: <CreditCardIcon className="w-4 h-4" data-id="element-63" />,
    text: 'Mercado Pago · Tarjeta · Transferencia'
  }, {
    icon: <FileTextIcon className="w-4 h-4" data-id="element-64" />,
    text: '100% PDF'
  }, {
    icon: <FlagIcon className="w-4 h-4" data-id="element-65" />,
    text: 'Hecho en Argentina'
  }];
  return <section className="w-full bg-neutral-950 py-4 md:py-8" data-id="element-66">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-68">
          <div className="text-center mb-4 md:mb-6 max-w-3xl mx-auto" data-id="element-69">
            <p className="text-lg md:text-2xl text-neutral-300 italic leading-relaxed" data-id="element-70">
              "Las velas comestibles no son una moda pasajera. Son una categoría
              de producto que llegó para quedarse. La pregunta no es si vas a
              aprender esto — la pregunta es si lo vas a aprender antes o
              después que los demás en tu ciudad."
            </p>
          </div>

          <div className="max-w-2xl mx-auto mb-3 md:mb-6" data-id="element-71">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-neutral-900 border-2 border-amber-500 rounded-lg p-5 md:p-6 relative shadow-[0_0_30px_rgba(251,191,36,0.15)]" data-id="element-72">
              <h4 className="text-xl font-bold text-amber-50 mb-1" data-id="element-73">
                🕯️ MEGA PACK VELAS COMESTIBLES GOURMET
              </h4>
              <p className="text-amber-400 font-semibold mb-2 text-sm" data-id="element-74">
                6 Tomos + 3 Bonos · Precio de lanzamiento
              </p>
              <div className="mb-3" data-id="element-75">
                <div className="flex items-baseline gap-2" data-id="element-76">
                  <span className="text-neutral-500 line-through text-lg" data-id="element-77">
                    $33.980
                  </span>
                  <span className="text-amber-400 font-bold text-3xl" data-id="element-78">
                    $16.990
                  </span>
                  <span className="text-neutral-500 text-sm" data-id="element-79">ARS</span>
                </div>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48298368336064:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-neutral-950 font-bold text-lg px-6 py-3.5 rounded-lg transition-colors shadow-[0_0_30px_rgba(251,191,36,0.25)] text-center" data-id="element-80">
                🛒 SÍ, QUIERO EMPEZAR HOY
              </motion.a>
            </motion.div>
          </div>

          <div className="flex flex-wrap gap-1.5 md:gap-2 items-center justify-center" data-id="element-81">
            {trustBadges.map((badge, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.3
          }} className="flex items-center gap-1 md:gap-1.5 bg-neutral-900 border border-amber-900/40 rounded-full px-2 py-1 md:px-3 md:py-1.5" data-id="element-82">
                <span className="text-amber-400 [&>svg]:w-3 [&>svg]:h-3 md:[&>svg]:w-4 md:[&>svg]:h-4" data-id="element-83">
                  {badge.icon}
                </span>
                <span className="text-[10px] md:text-xs text-neutral-300 font-medium leading-tight" data-id="element-84">
                  {badge.text}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}